module.exports = __webpack_public_path__ + "static/media/sarvvidLogodark.0f612b73.svg";